import { APIModel } from './api-model.model'
import { APIMenuItem } from './menu-item.model'

export class APIMenu extends APIModel {
    menuId: number;
    menuName: string;
    menuDescription: string;
    menuEnabled: number;
    menuItems?: APIMenuItem[];

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        menuId: number;
        menuName: string;
        menuDescription: string;
        menuEnabled: number;
        menuItems?: APIMenuItem[];
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.menuId = params.menuId
        this.menuName = params.menuName
        this.menuDescription = params.menuDescription
        this.menuEnabled = params.menuEnabled ? 1 : 0
        this.menuItems = params.menuItems
    }
}
